module.exports = __webpack_public_path__ + "static/logo_associazione-68dcc045a6fa10b6930c258c6df72e00.png";